import { REPAY_HELPER_ABI } from '@/config/abis/RepayHelperAbi.abi'
import { hyperEVM } from '@/config/chain/constants'
import { ensureConfigTypes } from '@/domain/hooks/useWrite'
import { MAX_UINT256 } from '@/domain/types/NumericValues'
import { getPortfolioBalanceInvalidationKeys } from '@/features/actions/logic/invalidation'
import { ActionConfig, ActionContext } from '../../../logic/types'
import { IsolatedRepayAction } from '../types'

export function createIsolatedRepayActionConfig(action: IsolatedRepayAction, context: ActionContext): ActionConfig {
  const { account, chainId } = context

  return {
    getWriteConfig: () => {
      return ensureConfigTypes({
        abi: REPAY_HELPER_ABI,
        address: hyperEVM.contracts.repayHelper.address,
        functionName: 'repay',
        chainId,
        args: [
          action.pairAddress as `0x${string}`,
          action.repayFull ? MAX_UINT256 : BigInt(Number(action.value) * 10 ** action.token.decimals),
        ],
      })
    },
    invalidates: () => getPortfolioBalanceInvalidationKeys({ account, chainId }),
  }
}
